import { createFileRoute } from '@tanstack/react-router'
import { ArchivedItemsPage, parseArchiveSearch } from '../../../components/archive/ArchivedItemsPage'

export const Route = createFileRoute('/$org/settings/archive')({
    component: ArchivePage,
    validateSearch: parseArchiveSearch,
})

// The archived-items review page (spec 2026-10-08-02), `archive.read`. Its
// tab, filters, sort and page live in the URL (issue #1522).
function ArchivePage() {
    const { org } = Route.useParams()
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
        <ArchivedItemsPage
            org={org}
            search={search}
            onSearchChange={(next, options) => navigate({ search: next, replace: options?.replace })}
        />
    )
}
